import axios from '@/user/axios.js'

const moduleAuth = {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async redirectResource (context) {
      try {
        const response = await axios.get('/api/resource')
        window.open(response.data.data, '_blank')
      } catch (e) {
        console.error(e)
        // TODO グローバルでエラー管理してそちらにわたす
      }
    }
  }
}

export default moduleAuth
